import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import store from '@/store/store'
import { useI18n } from 'vue-i18n-composable'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import LexonSwitchComponent from '@/components/forms/fields/LexonSwitch/LexonSwitchComponent.vue'
import LexonTextFieldComponent from '@/components/forms/fields/LexonTextField/LexonTextFieldComponent.vue'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateActionDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: { id: string; name: string }
};

const { t } = useI18n()



const actionName = ref(`DUPLICADO - ${props.componentProps.name}`)
const classification = ref(false)
const maxChar = ref(400)
const validationRules = ref(`required|max:${maxChar.value}`)

const texts = {
  explanation: t('components.duplicate_action.explanation'),
  nameLabel: t('components.duplicate_action.name_label'),
  classificationLabel: t('components.duplicate_action.classification_label'),
  title: t('components.duplicate_action.title')
}

const disabledActionButton = computed(() => {
  return actionName.value && actionName.value.length > maxChar.value
})

onMounted(async () => {
  actionName.value = `DUPLICADO - ${props.componentProps.name}`
})

const duplicateExpedient = () => {
  const expedientData = {
    id: props.componentProps.id,
    name: actionName.value,
    classification: classification.value,
    originalName: props.componentProps.name
  }
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
  store.dispatch(`${ModuleNamespaces.ACTIONS}/duplicateAction`, expedientData)
}

return { __sfc: true,t, props, actionName, classification, maxChar, validationRules, texts, disabledActionButton, duplicateExpedient, CustomDialogActionButtonsComponent, CustomDialogHeaderComponent, LexonSwitchComponent, LexonTextFieldComponent }
}

})